import {Avatar} from '@sollapay/ui/components';

import {getInitials} from '@/utils/get-initials.utils';

import {formatBuyerDisplayName, getBuyerAvatarShape} from '../utils';

import type {BuyerDTO} from '@sollapay/types';
import type {FC} from 'react';

export interface BuyerAvatarProps {
  buyer: Pick<BuyerDTO, 'id' | 'fullName' | 'partyType'>;
  size?: 'xs' | 'sm' | 'default' | 'lg' | 'xl';
}

export const BuyerAvatar: FC<BuyerAvatarProps> = ({buyer, size = 'lg'}) => (
  <Avatar
    initials={getInitials(formatBuyerDisplayName(buyer.fullName))}
    size={size}
    shape={getBuyerAvatarShape(buyer.partyType)}
    seed={buyer.id}
    noShadow
  />
);
